module.exports = __webpack_public_path__ + "img/wx_icon_bg.940adb09.png";